<div class="container-close">
    <a (click)="close()" title="Fechar">
        <i class="material-icons">close</i>
    </a>
</div>
<h1>Relatórios solicitados</h1>

<div class="container-text">
    <ng-container *ngFor="let rep of lazyReportsInfo; let i = index">

        <div class="card card-report-lazyInfo" [title]="handlePeriod(rep.period)">
            <div class="card-close" (click)="removeCard(rep,i)">
                <i class="material-icons">close</i>
            </div>
            <div class="card-content">
                <p class="report-lazy-info">{{rep.reportName}} - {{rep.dateRequest}} 
                    <span *ngIf="rep.status=='0'">
                        {{handleStatusReport(rep.status) }} 
                    </span>
                    
                   <span class="lazy-repo-download" *ngIf="rep.status=='1'" (click)="downloadFile(rep)">{{handleStatusReport(rep.status)}}
                    </span>
                </p>


            </div>

        </div>
    </ng-container>
</div>